import styled from 'styled-components';

const BulletsContainer = styled.div`
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Bullet = styled.button`
  margin: 0 -14px;  
  border-radius: 50%;
  width: 6px;
  height: 6px;
  background-color: white;
  border: 4px solid #000 !important;
  transform: scale(0.25);
  &.active {
    background-color: #969696;
  }

  &:focus-visible {
    outline: 4px solid #000 !important;
    outline-offset: 4px;
  }
`;

const ProgressIndicator = ({
  data, index, setIndex, accessibilityLabel
}) => (
  <BulletsContainer>
    {data && Object.keys(data).map((item, i) => (
      <Bullet
        type="button"
        aria-label={`${accessibilityLabel} carousel indicator ${i + 1} of ${data.length}, ${i === index ? 'active' : 'inactive'}`}
        onClick={() => setIndex(i)}
        key={item.id}
        className={i === index ? 'active' : ''}
      />
    ))}
  </BulletsContainer>
);

export default ProgressIndicator;
